export default function StraightArrowIcon() {
    return <svg xmlns="http://www.w3.org/2000/svg" width="50.922" height="15.448" viewBox="0 0 50.922 15.448">
    <g id="cicalese_arrow-right" transform="translate(0 14.678) rotate(-90)">
      <path id="Pfad_22" data-name="Pfad 22" d="M0,0,6.954,14.934,13.907,0" transform="translate(0 33.974)" fill="none" stroke="#fff" stroke-width="1.7"/>
      <line id="Linie_3" data-name="Linie 3" y1="48.908" transform="translate(7.028 0)" fill="none" stroke="#fff" stroke-width="1.7"/>
    </g>
  </svg>;
}